import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/pt-br';
dayjs.extend(customParseFormat);
dayjs.locale('pt-br');

export function generateMonthlyDateRangeArray(
  startDate,
  endDate,
  inputDateFormat = 'MM/YYYY',
  outputDateFormat = 'MM/YYYY'
) {
  startDate = dayjs(startDate, inputDateFormat).format("YYYY-MM");
  endDate = dayjs(endDate, inputDateFormat).format("YYYY-MM");

  let start = startDate.split('-');
  let end = endDate.split('-');
  let startYear = parseInt(start[0]);
  let endYear = parseInt(end[0]);
  let dates = [];

  for (let i = startYear; i <= endYear; i++) {
    let endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
    let startMon = i === startYear ? parseInt(start[1]) - 1 : 0;

    for (let j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
      let month = j + 1;
      let displayMonth = month < 10 ? '0' + month : month;

      let date = dayjs([i, displayMonth].join('-')).format(outputDateFormat);

      dates.push(date);
    }
  }

  return dates;
}

export function generateMonthlyDateRangeArrayPortuguese(
  startDate,
  endDate,
  inputDateFormat = 'MM/YYYY'
) {
  startDate = dayjs(startDate, inputDateFormat).format("YYYY-MM");
  endDate = dayjs(endDate, inputDateFormat).format("YYYY-MM");

  let start = startDate.split('-');
  let end = endDate.split('-');
  let startYear = parseInt(start[0]);
  let endYear = parseInt(end[0]);
  let dates = [];

  const mesesPortugues = {
    1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr',
    5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago',
    9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez'
  };

  for (let i = startYear; i <= endYear; i++) {
    let endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
    let startMon = i === startYear ? parseInt(start[1]) - 1 : 0;

    for (let j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
      let month = j + 1;
      let displayMonth = mesesPortugues[month];
      dates.push(displayMonth);
    }
  }

  return dates;
}